import posed from "react-pose";
import { styled } from "@lib/components";

const DEFAULT_BG_IMAGE =
	"https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200&auto=format&fit=crop&q=80";

const Shell = styled("div")`
	min-height: 100vh;
	min-height: 100dvh;
	box-sizing: border-box;
	padding: var(--cw-safe-top, 0px) var(--cw-safe-right, 0px) var(--cw-safe-bottom, 0px) var(--cw-safe-left, 0px);
	display: flex;
`;

const LeftPanel = styled("div")`
	display: none;
	position: relative;
	overflow: hidden;

	@media (min-width: 1024px) {
		display: flex;
		width: 50%;
	}
`;

const LeftImage = styled("img")`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

const LeftOverlay = styled("div")<{ bg_tint?: string }>`
	position: absolute;
	inset: 0;
	background: ${(props) => props.bg_tint || "rgba(15, 23, 42, 0.3)"};
`;

const LeftFooter = styled("div")`
	position: absolute;
	bottom: 24px;
	left: 24px;
	color: white;
	font-size: 14px;
	opacity: 0.75;
	z-index: 1;
`;

const MainPose = posed.div({
	visible: {
		opacity: 1,
		translateY: 0,
	},
	hidden: {
		opacity: 0,
		translateY: 14,
	},
});

const RightPanel = styled(MainPose)<{ boxStyle?: string }>`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: ${(props) => (props.boxStyle === "expanded" ? "64px 32px" : "48px 24px")};
	background: white;
	min-height: 100vh;
	min-height: 100dvh;
`;

const Content = styled("div")`
	width: 100%;
	max-width: 384px;
	position: relative;
`;

const LogoHeader = styled("div")`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 32px;

	img {
		height: 40px;
		width: auto;
		max-height: 40px;
		object-fit: contain;
	}
`;

const LogoTitle = styled("div")`
	font-size: 20px;
	font-weight: 700;
	color: #1e293b;
	line-height: 1.2;
`;

const LogoSubtitle = styled("div")`
	font-size: 12px;
	color: #94a3b8;
	margin-top: -2px;
`;

const ContentBox = styled("div")`
	position: relative;
`;

export const AuthLayoutComponents = {
	Shell,
	LeftPanel,
	LeftImage,
	LeftOverlay,
	LeftFooter,
	RightPanel,
	Content,
	LogoHeader,
	LogoTitle,
	LogoSubtitle,
	ContentBox,
	DEFAULT_BG_IMAGE,
};
